import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"z-index":"1000"},
  class: "fixed top-0 left-0 flex items-center justify-center w-full h-full"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "icon-surrounding bg-danger-light text-danger-dark" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " priority_high ")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-yellow-900 bg-yellow-500 icon-surrounding" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ml-px material-icons-outlined" }, " priority_high ")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "icon-surrounding bg-success-light text-success-dark" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " check ")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "flex ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinearProgress = _resolveComponent("LinearProgress")!
  const _component_Btn = _resolveComponent("Btn")!

  return _withDirectives((_openBlock(), _createBlock(_Transition, {
    name: "fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss())),
          style: {"width":"100vw !important","height":"100vh !important"},
          class: "absolute z-10 w-full h-full transition-none bg-gray-900 opacity-80"
        }),
        _createVNode(_Transition, { name: "bounce" }, {
          default: _withCtx(() => [
            (_ctx.showDialog)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["relative z-20 max-h-full overflow-y-auto mx-1.5 bg-white rounded-md shadow-all-around md:mx-0 flex flex-col", {
						'md:max-w-4xl md:min-w-md': !_ctx.fullWidth && !_ctx.large,
						'w-4/5 md:w-3/4 md:mx-4': _ctx.large,
						'w-full md:w-full md:mx-4': _ctx.fullWidth,
						[_ctx.dialogBoxClasses]: true,
					}]),
                  style: _normalizeStyle(_ctx.fullHeight ? 'height: calc(100vh - 10px)' : '')
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_LinearProgress, {
                        key: 0,
                        class: "rounded-t-md absolute top-0 left-0"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    style: {},
                    class: _normalizeClass(["w-full overflow-y-auto", { 'px-4 md:px-8': !_ctx.noPadding }])
                  }, [
                    (_ctx.$slots.title)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["flex items-center space-x-2 bg-white", {
								'py-2': !_ctx.noPadding && _ctx.$slots.backButton?.(),
								'pt-4': !_ctx.noPadding && !_ctx.$slots.backButton?.(),
								'sticky top-0 z-50': _ctx.stickyHeader,
								'border-b border-gray-200 -mx-4 md:-mx-8 px-8': _ctx.headerBorder,
							}])
                        }, [
                          _renderSlot(_ctx.$slots, "backButton", { class: "" }),
                          (_ctx.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                            : (_ctx.warning)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                              : (_ctx.success)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                                : _createCommentVNode("", true),
                          _createElementVNode("h2", _hoisted_11, [
                            _renderSlot(_ctx.$slots, "title")
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["pb-3 text-gray-600", [
								!_ctx.$slots.title ? 'pt-6' : _ctx.error || _ctx.warning || _ctx.success ? 'pt-4' : 'pt-3',
							]])
                    }, [
                      _renderSlot(_ctx.$slots, "body")
                    ], 2)
                  ], 2),
                  (_ctx.showActions)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["z-50 flex flex-col items-center pt-2 pb-2 pr-2 mt-auto md:flex-row", {
							'border-t border-gray-200': _ctx.footerBorder,
						}])
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _renderSlot(_ctx.$slots, "footerButtons")
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_Btn, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitChoice('yes'))),
                            variant: 'primary-borderless',
                            disabled: _ctx.disableOk
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.yesText ||
									(_ctx.confirmOnly
										? _ctx.$t("dialog.default_ok_text")
										: _ctx.$t("dialog.default_yes_text"))), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          (!_ctx.confirmOnly)
                            ? (_openBlock(), _createBlock(_component_Btn, {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitChoice('no'))),
                                variant: 'primary-borderless'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.noText || _ctx.$t("dialog.default_no_text")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
                ], 6))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ])
    ]),
    _: 3
  }, 512)), [
    [_vShow, _ctx.showDialog]
  ])
}